export class BackEndCommission {
    /** Total dollar value of the back end commission. */
    total: number = 0;

    /** A list fo products associated with the backend commission calc. */
    products: Object | null = null;
}